import { Box, useTheme } from '@mui/material';
import React from 'react';

import treeCampus from '../assets/logo-tree-campus.svg';
import treeCityWorldWide from '../assets/logo-tree-cities-world.svg';
import treeCityUSA from '../assets/logo-tree-city-usa.svg';
import treeline from '../assets/logo-tree-line.svg';

function Footer() {
  const theme = useTheme();

  const imgStyle = {
    height: '90px',
  };

  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='space-around'
      height='130px'
      width='100vw'
      sx={{ background: theme.palette.sandTint.main }}
    >
      <img style={imgStyle} src={treeCampus} alt={'Tree Campus'} />
      <img style={imgStyle} src={treeCityWorldWide} alt={'Tree Cities of the World'} />
      <img style={imgStyle} src={treeCityUSA} alt={'Tree City USA'} />
      <img style={imgStyle} src={treeline} alt={'Tree Line USA'} />
    </Box>
  );
}

export default Footer;
